export class ConfigManager {
  constructor() {
    this.defaultConfig = {
      pushUrl:
        import.meta.env.VITE_RTMP_PUSH_URL ||
        "rtmp://push.wdxuetang.cn/wendingxuetang/xxx",
      pullUrl:
        import.meta.env.VITE_HTTP_PULL_URL ||
        "https://pull.wdxuetang.cn/wendingxuetang/shuangjidds.m3u8",
      streamParams: {
        videoBitrate: parseInt(import.meta.env.VITE_VIDEO_BITRATE) || 1500,
        audioBitrate: parseInt(import.meta.env.VITE_AUDIO_BITRATE) || 64,
        frameRate: parseInt(import.meta.env.VITE_FRAME_RATE) || 15,
        resolution: {
          width: parseInt(import.meta.env.VITE_RESOLUTION_WIDTH) || 640,
          height: parseInt(import.meta.env.VITE_RESOLUTION_HEIGHT) || 480,
        },
      },
      detectTimeout: parseInt(import.meta.env.VITE_DETECT_TIMEOUT) || 10000,
      reconnect: {
        enabled: import.meta.env.VITE_RECONNECT_ENABLED !== "false",
        maxAttempts: parseInt(import.meta.env.VITE_RECONNECT_MAX_ATTEMPTS) || 3,
        interval: parseInt(import.meta.env.VITE_RECONNECT_INTERVAL) || 2000,
      },
      language: import.meta.env.VITE_LANGUAGE || "zh-CN",
      debug: import.meta.env.VITE_DEBUG_MODE === "true",
    };

    this.config = { ...this.defaultConfig };
    this.loadSavedConfig();
  }

  loadSavedConfig() {
    try {
      const savedConfig = localStorage.getItem("shuangjiwei_config");
      if (savedConfig) {
        const parsedConfig = JSON.parse(savedConfig);

        this.config = {
          ...this.config,
          ...parsedConfig,
          pushUrl: parsedConfig.pushUrl || this.defaultConfig.pushUrl,
          pullUrl: parsedConfig.pullUrl || this.defaultConfig.pullUrl,
        };
      }
    } catch (error) {
      console.warn("加载配置失败:", error);
    }
  }

  saveConfig() {
    try {
      const userConfig = {
        streamParams: this.config.streamParams,
        detectTimeout: this.config.detectTimeout,
        reconnect: this.config.reconnect,
        language: this.config.language,
        debug: this.config.debug,
      };

      localStorage.setItem("shuangjiwei_config", JSON.stringify(userConfig));
    } catch (error) {
      console.error("保存配置失败:", error);
    }
  }

  get(key) {
    return this.config[key];
  }

  set(key, value) {
    this.config[key] = value;
    this.saveConfig();
  }

  update(newConfig) {
    this.config = { ...this.config, ...newConfig };
    this.saveConfig();
  }

  getAll() {
    return { ...this.config };
  }

  isValidPushUrl(url) {
    try {
      const parsed = new URL(url);
      return ["rtmp:", "rtmps:"].includes(parsed.protocol);
    } catch {
      return false;
    }
  }

  isValidPullUrl(url) {
    try {
      // artc:// 是阿里云 RTS 的特殊协议，需要单独处理
      if (url.startsWith('artc://')) {
        return true;
      }
      const parsed = new URL(url);
      return ["http:", "https:", "ws:", "wss:"].includes(parsed.protocol);
    } catch {
      return false;
    }
  }

  reset() {
    this.config = { ...this.defaultConfig };
    this.saveConfig();
  }

  init() {
    this.loadSavedConfig();
    return this;
  }
}

const configManager = new ConfigManager();

export default configManager;
